import trade from "./trade";
import orders from "./orders";
import createPersistedState from "vuex-persistedstate";
import { FusionProject } from "@/types";

const namespace: FusionProject = "trade";

export const plugins = [
  createPersistedState({
    key: namespace,
    paths: [
      namespace,
      namespace + ".orders.tradeTabIndex",
      namespace + ".orders.orderTabIndex",
      namespace + ".orders.showFiatTradeStatementModal"
    ]
  })
];

export default {
  ...trade,
  modules: {
    orders
  }
};
